import { formatDate } from '@angular/common';
import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import { error } from 'console';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { BaseChartDirective } from 'ng2-charts';
import { NgxSpinnerService } from 'ngx-spinner';
import { NodeUsage } from '../../../../core/models/charts';
import { GraphDataGranularity, Graphs } from '../../../../core/models/globals';
import { ActionLogService } from '../../../../core/services/action-log.service';
import { ChartsService } from '../../../../core/services/charts.service';

@Component({
  selector: 'app-node-reports',
  templateUrl: './node-reports.component.html',
  styleUrls: ['./node-reports.component.scss']
})
export class NodeReportsComponent implements OnInit {

  constructor(
    private chartService: ChartsService,
    public spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    public dialog: MatDialogRef<NodeReportsComponent>,
    private actionLogService: ActionLogService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depName: string,
      wsName: string,
    },
    private snackbar: MatSnackBar
  ) { Chart.register(Annotation) }

  nodeUtilization: NodeUsage[] = [];
  selectedMetric = 'all';
  dateFilterValue = '7';
  granularityValue = 'One Hour';
  depName: string = this.data.depName;
  availableGranularity = [];


  ngOnInit(): void {
    /*this.chartService.getGranularity().subscribe((data: []) => {
      this.availableGranularity = data;
    });*/
    this.changeGranularityOptions(this.dateFilterValue)
    this.loadNodeUtilization();
  }

  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;

  nodeUtilizationOptionsTotal: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        }
      },
      'y-axis-0':
      {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        },
        max: 100,
        min: 0
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12
          }
        },
      },
      title: {
        display: true,
        text: '24 Hours',
        position: 'top',
      },
      datalabels: {
        display: false
      },
    },
  };
  nodeUtilizationOptionsTotalOffice: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        }
      },
      'y-axis-0':
      {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        },
        max: 100,
        min: 0
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12
          }
        },
      },
      title: {
        display: true,
        text: 'Office Hours',
        position: 'top',
      },
      datalabels: {
        display: false
      },
    },
  };
  nodeUtilizationOptionsNonOffice: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        }
      },
      'y-axis-0':
      {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black'
        },
        max: 100,
        min: 0
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12
          }
        },
      },
      title: {
        display: true,
        text: 'Non-Office Hours',
        position: 'top',
      },
      datalabels: {
        display: false
      },
    },
  };
  nodeUtilizationType: ChartType = 'line';
  nodeUtilizationDataTotal: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointBorderColor: 'red',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: 'red',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(152, 251, 152, 0.3)',
        borderColor: '#32CD32',
        pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointBorderColor: '#32CD32',
        pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointHoverBorderColor: '#32CD32',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(255,225,153,0.3)',
        pointBorderColor: 'gold',
        pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
        pointHoverBorderColor: 'gold',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(125, 249, 2553, 0.3)',
        borderColor: 'cyan',
        pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointBorderColor: 'cyan',
        pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointHoverBorderColor: 'cyan',
        fill: 'origin',
      }
    ],
    labels: []
  };
  nodeUtilizationDataOffice: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointBorderColor: 'red',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: 'red',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(152, 251, 152, 0.3)',
        borderColor: '#32CD32',
        pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointBorderColor: '#32CD32',
        pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointHoverBorderColor: '#32CD32',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(255,225,153,0.3)',
        pointBorderColor: 'gold',
        pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
        pointHoverBorderColor: 'gold',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(125, 249, 2553, 0.3)',
        borderColor: 'cyan',
        pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointBorderColor: 'cyan',
        pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointHoverBorderColor: 'cyan',
        fill: 'origin',
      }
    ],
    labels: []
  };
  nodeUtilizationDataNonOffice: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointBorderColor: 'red',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: 'red',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(152, 251, 152, 0.3)',
        borderColor: '#32CD32',
        pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointBorderColor: '#32CD32',
        pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
        pointHoverBorderColor: '#32CD32',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(255,225,153,0.3)',
        pointBorderColor: 'gold',
        pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
        pointHoverBorderColor: 'gold',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(125, 249, 2553, 0.3)',
        borderColor: 'cyan',
        pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointBorderColor: 'cyan',
        pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
        pointHoverBorderColor: 'cyan',
        fill: 'origin',
      }
    ],
    labels: []
  };

  loadNodeUtilization() {
    this.spinner.show('reports');
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        this.data.wsName,
        false,
        ''
      )
      .subscribe((data) => {
        if (data) {
          this.nodeUtilization = <NodeUsage[]>JSON.parse(JSON.stringify(data));
          if (this.nodeUtilization) {
            //const uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];
            let uniqueDates;
            if (this.dateFilterValue != '1') {
              uniqueDates = [...new Set(this.nodeUtilization.map(item => formatDate(new Date(item.timeStamp), 'mediumDate', 'en-US').split(',')[0]))];
            }
            else {
              uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];
            }
            this.nodeUtilization.forEach((x) => {
              if (x.officeHours == 1) {
                this.nodeUtilizationDataOffice.datasets[0].data.push(x.cpuPercent);
                this.nodeUtilizationDataOffice.datasets[1].data.push(x.ramPercent);
                this.nodeUtilizationDataOffice.datasets[2].data.push(x.gpuPercent);
                this.nodeUtilizationDataOffice.datasets[3].data.push(x.gpuMemoryUsage);
                let date;
                if (this.dateFilterValue == '1') {
                  date = formatDate(new Date(x.timeStamp), 'h:mm aa', 'en-US').split(')')[0];
                } else {
                  date = formatDate(new Date(x.timeStamp), 'mediumDate', 'en-US').split(',')[0];
                }
                this.nodeUtilizationDataOffice.labels.push(date);
              }
              else if (x.officeHours == 0) {
                this.nodeUtilizationDataNonOffice.datasets[0].data.push(x.cpuPercent);
                this.nodeUtilizationDataNonOffice.datasets[1].data.push(x.ramPercent);
                this.nodeUtilizationDataNonOffice.datasets[2].data.push(x.gpuPercent);
                this.nodeUtilizationDataNonOffice.datasets[3].data.push(x.gpuMemoryUsage);
                let date;
                if (this.dateFilterValue == '1') {
                  date = formatDate(new Date(x.timeStamp), 'h:mm aa', 'en-US').split(')')[0];
                } else {
                  date = formatDate(new Date(x.timeStamp), 'mediumDate', 'en-US').split(',')[0];
                }
                this.nodeUtilizationDataNonOffice.labels.push(date);
              }
            });

            uniqueDates.forEach((unq) => {
              let count = 0;
              let ramUsage = 0;
              let cpuUsage = 0;
              let gpuUsage = 0;
              let gpuMemoryUsage = 0;
              this.nodeUtilization.forEach((n) => {
                if (this.dateFilterValue != '1') {
                  if ((formatDate(new Date(n.timeStamp), 'mediumDate', 'en-US').split(',')[0]) === unq) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                }
                else {
                  if (n.timeStamp === unq) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                }
              })
              this.nodeUtilizationDataTotal.datasets[0].data.push(cpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[1].data.push(ramUsage / count);
              this.nodeUtilizationDataTotal.datasets[2].data.push(gpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[3].data.push(gpuMemoryUsage / count);
              let date;
              if (this.dateFilterValue == '1') {
                date = formatDate(new Date(unq), 'h:mm aa', 'en-US').split(')')[0];
              } else {
                date = formatDate(new Date(unq), 'mediumDate', 'en-US').split(',')[0];
              }
              this.nodeUtilizationDataTotal.labels.push(date);
            })

            //this.nodeUtilizationChart.update();
            this.charts.forEach((child) => {
              child.chart.update()
            });
          }
          else {
            this.spinner.hide('reports');
            this.snackbar.open("No node utilization report found.", "OK", {
              duration: 5000
            });
          }
        }
        this.spinner.hide('reports');
      }, error => {
        this.spinner.hide('reports');
        this.snackbar.open("Unable to find node utilization report.", "OK", {
          duration: 5000
        });
      });
  }

  applyFilters(metric, date, granularity, user, application) {
    this.resetAllData();
    this.selectedMetric = metric;
    this.dateFilterValue = date;
    this.granularityValue = granularity;
    this.loadNodeUtilization()
  }

  generatePdf() {
    const div = document.getElementById("html2Pdf");
    const options = { background: "white", height: div.clientHeight, width: div.clientWidth };

    html2canvas(div, options).then((canvas) => {
      //Initialize JSPDF
      let doc = new jsPDF("l", "mm", "a4");
      //Converting canvas to Image
      let imgData = canvas.toDataURL("image/PNG");
      //Add image Canvas to PDF
      const bufferX = 5;
      const bufferY = 5;
      const imgProps = (<any>doc).getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(imgData, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');

      let pdfOutput = doc.output();
      // using ArrayBuffer will allow you to put image inside PDF
      let buffer = new ArrayBuffer(pdfOutput.length);
      let array = new Uint8Array(buffer);
      for (let i = 0; i < pdfOutput.length; i++) {
        array[i] = pdfOutput.charCodeAt(i);
      }

      //Name of pdf
      const fileName = this.depName + "_Report_" + new Date().toISOString().slice(0, 10) + ".pdf";

      // Make file
      doc.save(fileName);

    });
  }

  onClose() {
    this.dialog.close(false);
  }

  resetAllData() {
    this.nodeUtilizationDataTotal = {
      datasets: [
        {
          data: [],
          label: 'CPU',
          backgroundColor: 'rgba(255, 161, 181,0.3)',
          borderColor: 'red',
          pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointBorderColor: 'red',
          pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointHoverBorderColor: 'red',
          fill: 'origin',
        },
        {
          data: [],
          label: 'RAM',
          backgroundColor: 'rgba(152, 251, 152, 0.3)',
          borderColor: '#32CD32',
          pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointBorderColor: '#32CD32',
          pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointHoverBorderColor: '#32CD32',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU',
          backgroundColor: 'rgba(255,225,153,0.3)',
          borderColor: 'gold',
          pointBackgroundColor: 'rgba(255,225,153,0.3)',
          pointBorderColor: 'gold',
          pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
          pointHoverBorderColor: 'gold',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU RAM',
          backgroundColor: 'rgba(125, 249, 2553, 0.3)',
          borderColor: 'cyan',
          pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointBorderColor: 'cyan',
          pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointHoverBorderColor: 'cyan',
          fill: 'origin',
        }
      ],
      labels: []
    };
    this.nodeUtilizationDataOffice = {
      datasets: [
        {
          data: [],
          label: 'CPU',
          backgroundColor: 'rgba(255, 161, 181,0.3)',
          borderColor: 'red',
          pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointBorderColor: 'red',
          pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointHoverBorderColor: 'red',
          fill: 'origin',
        },
        {
          data: [],
          label: 'RAM',
          backgroundColor: 'rgba(152, 251, 152, 0.3)',
          borderColor: '#32CD32',
          pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointBorderColor: '#32CD32',
          pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointHoverBorderColor: '#32CD32',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU',
          backgroundColor: 'rgba(255,225,153,0.3)',
          borderColor: 'gold',
          pointBackgroundColor: 'rgba(255,225,153,0.3)',
          pointBorderColor: 'gold',
          pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
          pointHoverBorderColor: 'gold',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU RAM',
          backgroundColor: 'rgba(125, 249, 2553, 0.3)',
          borderColor: 'cyan',
          pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointBorderColor: 'cyan',
          pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointHoverBorderColor: 'cyan',
          fill: 'origin',
        }
      ],
      labels: []
    };
    this.nodeUtilizationDataNonOffice = {
      datasets: [
        {
          data: [],
          label: 'CPU',
          backgroundColor: 'rgba(255, 161, 181,0.3)',
          borderColor: 'red',
          pointBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointBorderColor: 'red',
          pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
          pointHoverBorderColor: 'red',
          fill: 'origin',
        },
        {
          data: [],
          label: 'RAM',
          backgroundColor: 'rgba(152, 251, 152, 0.3)',
          borderColor: '#32CD32',
          pointBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointBorderColor: '#32CD32',
          pointHoverBackgroundColor: 'rgba(152, 251, 152, 0.3)',
          pointHoverBorderColor: '#32CD32',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU',
          backgroundColor: 'rgba(255,225,153,0.3)',
          borderColor: 'gold',
          pointBackgroundColor: 'rgba(255,225,153,0.3)',
          pointBorderColor: 'gold',
          pointHoverBackgroundColor: 'rgba(255,225,153,0.3)',
          pointHoverBorderColor: 'gold',
          fill: 'origin',
        },
        {
          data: [],
          label: 'GPU RAM',
          backgroundColor: 'rgba(125, 249, 2553, 0.3)',
          borderColor: 'cyan',
          pointBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointBorderColor: 'cyan',
          pointHoverBackgroundColor: 'rgba(125, 249, 2553, 0.3)',
          pointHoverBorderColor: 'cyan',
          fill: 'origin',
        }
      ],
      labels: []
    };
  }

  downloadAllCanvas() {
    for (let index = 0; index < document.getElementsByTagName('canvas').length; index++) {
      let elementAnchor = document.createElement('a');
      document.body.appendChild(elementAnchor);
      elementAnchor.setAttribute('style', 'display: none');
      let element = document.getElementsByTagName('canvas')[index];
      elementAnchor.href = element.toDataURL();
      elementAnchor.download = `${element.id}.jpg`;
      elementAnchor.click();
      elementAnchor.remove();
      this.actionLogService.addActionLog(this.depName, 'Report Downloaded', this.depName, 'Deployment', `Downloaded Report of ${element.id}`);
    }
  }

  changeGranularityOptions(days) {
    switch (days) {
      case "1":
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneHour);
        break;
      case "7":
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        break;
      case "30":
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        this.availableGranularity.push(GraphDataGranularity.OneMonth);
        break;
      case "90":
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        this.availableGranularity.push(GraphDataGranularity.OneMonth);
        break;
    }
  }
}
